var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58173 12.4183 0 8 0C3.58176 0 0 3.58176 0 8ZM9.13578 2.10735C9.33345 2.19361 9.51143 2.30841 9.6499 2.4567C10.5515 2.61548 11.2745 3.68293 11.2745 4.92853C11.2745 5.72758 11.1342 6.38488 11.0496 6.70998C11.1436 6.86923 11.2452 7.10549 11.2452 7.37956C11.2452 7.99905 10.9324 8.39976 10.6404 8.61382C10.5577 9.37744 10.1224 9.86982 9.85688 10.1032V10.8352C9.85688 11.2892 10.6798 11.5945 11.4759 11.8898C11.729 11.9835 12.0004 12.0972 12.2617 12.2234C11.1745 13.3205 9.66659 14 8 14C6.41355 14 4.97091 13.3843 3.898 12.3788C4.03776 12.3136 4.18321 12.2483 4.33232 12.1815L4.33355 12.1809C5.13998 11.819 6.14312 11.3689 6.14312 10.8352V10.1084C5.85723 9.86887 5.37287 9.35381 5.29679 8.57933C5.06524 8.36102 4.68106 7.91589 4.68106 7.36491C4.68106 7.03036 4.81337 6.76054 4.92962 6.58901C4.85874 6.23036 4.72548 5.4795 4.72548 4.92853C4.72548 3.66881 5.32421 2.71329 6.33674 2.23353C6.86488 2.08147 7.42293 2 8 2C8.38831 2 8.76801 2.03689 9.13578 2.10735Z",
    fill: "currentColor"
  })));
}

export default SvgUser;